<div class="flex flex-col">
    <div class="flex justify-between mb-1">
        <h3 class="site-name-color">{{dashboardService.translate('Select a site to proceed')}}</h3>
            <!-- <mat-icon [svgIcon]="'custom:close'" class="pointer relative "  (click)="onCloseBtnClick()"></mat-icon> -->
    </div>
</div>
<hr class="w-full my-4">
<div class="flex justify-center flex-row w-full">
    <div class="relative text-gray-600 focus-within:text-gray-400 rounded-2xl w-full min-w-4/5">
        <span class="absolute inset-y-0 right-0 flex items-center pl-2">
            <button class="p-1 focus:outline-none focus:shadow-outline">
                <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    viewBox="0 0 24 24" class="w-6 h-6">
                    <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                </svg>
            </button>
        </span>
        <input type="text" name="search" (input)="onSiteSearch($event.target.value)"
            class="shadow appearance-none border rounded rounded-2xl w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="searchLocation" [placeholder]="dashboardService.translate('Search location')"
            style="border-radius: 0.5rem !important;">
    </div>
    <button class=" ml-4 hover:shadow-lg text-white font-bold px-5 py-0 rounded-lg button-bg ">
        {{dashboardService.translate('Search')}}
    </button>
</div>

<div class=" mt-3 h-50  overflow-y-auto ">
    <div *ngIf="(!sites|| !sites.length)" class="py-5 text-center">No Sites Found</div> 
    <div class="text-left py-2 border-b border-gray-200 cursor-pointer" (click)="onSiteSelect(site)" *ngFor="let site of sites">
            {{dashboardService.translate(site[0].site_name)}}
    </div>
</div>